import CryptoJS from "crypto-js";
import Vue from "vue";
import store from "@/store";

import moment from "moment-timezone";

export default {
  crypKey: "A",

  cloneObject(obj) {
    return JSON.parse(JSON.stringify(obj));

    //Object.assign child obj can't be clone
    //return Object.assign({}, obj);
  },

  // clone object includes property and function, not work in vuex state value
  deepCloneObject(obj) {
    return Object.create(Object.getPrototypeOf(obj), Object.getOwnPropertyDescriptors(obj));
  },

  isEmptyObject(obj) {
    if (obj == null) return true;
    else return Object.keys(obj).length === 0;
  },

  isMobile() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true;
    } else {
      return false;
    }
  },

  isIOS() {
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      return true;
    } else {
      return false;
    }
  },

  isSafari() {
    if (/Safari/i.test(navigator.userAgent)) {
      return true;
    } else {
      return false;
    }
  },

  isChrome() {
    if (/Chrome/i.test(navigator.userAgent)) {
      return true;
    } else {
      return false;
    }
  },

  isAppleWebKit() {
    if (/AppleWebKit/i.test(navigator.userAgent)) {
      return true;
    } else {
      return false;
    }
  },

  isStandaloneApp() {
    return window.matchMedia("(display-mode: standalone)").matches;
  },

  roundNumber(value, precision) {
    //return Number(value.toFixed(precision));
    let p = Math.pow(10, precision);
    return Math.round(value * p) / p;
  },

  getRandomColor() {
    var letters = "0123456789ABCDEF".split("");
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  },

  getTimeId() {
    // 1. Get the current timestamp in milliseconds (13 digits)
    const fullTimestamp = Date.now().toString();

    // 2. Slice off the last character
    const twelveDigitId = fullTimestamp.slice(0, -1);

    // 3. Convert the result back to a number
    //return Number(twelveDigitId);

    return twelveDigitId;
  },

  isValidDate(date) {
    return date instanceof Date && !isNaN(date);
  },

  toDate(date) {
    let n_date = null;
    if (date) {
      if (this.isValidDate(date)) n_date = date;
      else if (Vue.prototype.$isSqlTimeFormat(date)) {
        n_date = new Date(date);
        if (!this.isValidDate(n_date)) n_date = new Date(date.replace(/ /g, "T"));
      } else n_date = new Date(date);
    }

    return n_date;
  },

  toLocaleString(date, useStoreTimeZone) {
    let localeString = null;
    try {
      let n_date = this.toDate(date);
      if (n_date) {
        let timeZone;
        if (useStoreTimeZone == null || useStoreTimeZone) timeZone = store.getters.storeTimeZone;
        localeString = n_date.toLocaleString(Vue.prototype.$deviceLocale, {
          timeZone: timeZone,
          dateStyle: "short",
          timeStyle: "short",
        });
      }
    } catch (error) {
      console.log(error);
    }

    return localeString;
  },

  toLocaleDateString(date, useStoreTimeZone) {
    let localeString = null;
    try {
      let n_date = this.toDate(date);
      if (n_date) {
        let timeZone;
        if (useStoreTimeZone == null || useStoreTimeZone) timeZone = store.getters.storeTimeZone;
        localeString = n_date.toLocaleDateString(Vue.prototype.$deviceLocale, {
          timeZone: timeZone,
          dateStyle: "short",
        });
      }
    } catch (error) {
      console.log(error);
    }

    return localeString;
  },

  // h:m am/pm
  toLocaleTimeString(date, useStoreTimeZone) {
    let localeString = null;
    try {
      let n_date = this.toDate(date);
      if (n_date) {
        let timeZone;
        if (useStoreTimeZone == null || useStoreTimeZone) timeZone = store.getters.storeTimeZone;
        localeString = n_date.toLocaleTimeString(Vue.prototype.$deviceLocale, {
          timeZone: timeZone,
          timeStyle: "short",
        });
      }
    } catch (error) {
      console.log(error);
    }

    return localeString;
  },

  // hh:mm am/pm
  toLocaleTime12String(date, useStoreTimeZone) {
    let localeString = null;
    try {
      let n_date = this.toDate(date);
      if (n_date) {
        let locale = "en-US";
        let timeZone;
        if (useStoreTimeZone == null || useStoreTimeZone) timeZone = store.getters.storeTimeZone;
        let hh = n_date.toLocaleString(locale, { timeZone: timeZone, hour: "2-digit", hour12: false });
        let mm = n_date.toLocaleString(locale, { timeZone: timeZone, minute: "2-digit" });
        if (hh == "24") hh = "00";

        let midday = false;
        let i_hh = parseInt(hh);
        if (i_hh >= 12) {
          midday = true;
        }
        if (i_hh > 12) {
          hh = (i_hh - 12).toString();
        }
        localeString = hh.padStart(2, "0") + ":" + mm.padStart(2, "0") + " " + (midday ? "pm" : "am");
      }
    } catch (error) {
      console.log(error);
    }

    return localeString;
  },

  // hh:mm
  toLocaleTime24String(date, useStoreTimeZone) {
    let localeString = null;
    try {
      let n_date = this.toDate(date);
      if (n_date) {
        let locale = "en-US";
        let timeZone;
        if (useStoreTimeZone == null || useStoreTimeZone) timeZone = store.getters.storeTimeZone;
        let hh = n_date.toLocaleString(locale, { timeZone: timeZone, hour: "2-digit", hour12: false });
        let mm = n_date.toLocaleString(locale, { timeZone: timeZone, minute: "2-digit" });
        if (hh == "24") hh = "00";
        localeString = hh.padStart(2, "0") + ":" + mm.padStart(2, "0");
      }
    } catch (error) {
      console.log(error);
    }

    return localeString;
  },

  toSQLDateString(date) {
    let sqlDate = null;
    let n_date = moment(date);
    if (n_date.isValid()) {
      let timeZone = store.getters.storeTimeZone;
      sqlDate = n_date.tz(timeZone).format("YYYY-MM-DD");
    }

    return sqlDate;
  },

  toSQLDateTimeString(date) {
    let sqlDate = null;
    let n_date = moment(date);
    if (n_date.isValid()) {
      let timeZone = store.getters.storeTimeZone;
      sqlDate = n_date.tz(timeZone).format("YYYY-MM-DD HH:mm:ss");
    }

    return sqlDate;
  },

  // output hh:mm or hh:mm am/pm
  toTimeString(date, hour12) {
    let stString;
    let n_date = moment(date);
    if (n_date.isValid()) {
      let timeZone = store.getters.storeTimeZone;
      if (hour12) stString = n_date.tz(timeZone).format("hh:mma");
      else stString = n_date.tz(timeZone).format("HH:mm");
    }

    return stString;
  },

  // output hh:mm am/pm
  stringToStandardTimeString(time) {
    if (typeof time != "string" || time.length != 5 || !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(time)) return time;
    else {
      let midday = false;
      let hh = time.substring(0, 2);
      let mm = time.substring(3, 3 + 2);

      if (hh == "00" && mm == "00") {
        return "Midnight";
      } else if (hh == "12" && mm == "00") {
        return "Noon";
      } else {
        if (hh >= "12") {
          midday = true;
        }
        if (hh > "12") {
          hh = (parseInt(hh) - 12).toString();
        } else {
          hh = parseInt(hh).toString();
        }

        return hh + ":" + mm + (midday ? "pm" : "am");
      }
    }
  },

  timeInRanges(times, timeString) {
    let inRange = false;
    if (times) {
      for (let tt of times) {
        if (tt.from && tt.to) {
          if (tt.from == tt.to || (tt.from <= timeString && (tt.to == "00:00" || tt.to >= timeString))) {
            inRange = true;
            break;
          }
        }
      }
    }
    return inRange;
  },

  timesToString(times) {
    let s = "";
    if (times) {
      times.forEach(tm => {
        s +=
          (s == "" ? "" : ", ") +
          this.stringToStandardTimeString(tm.from) +
          " - " +
          this.stringToStandardTimeString(tm.to);
      });
    }

    return s;
  },

  toInt(value) {
    let res = parseInt(value);
    if (isNaN(res)) {
      res = 0;
    }

    return res;
  },

  toFloat(value) {
    let res = parseFloat(value);
    if (isNaN(res)) {
      res = 0;
    }

    return res;
  },

  range(start, end) {
    if (start > end)
      return Array(start - end + 1)
        .fill()
        .map((_, idx) => start - idx);
    else
      return Array(end - start + 1)
        .fill()
        .map((_, idx) => start + idx);
  },

  coordsToRect(coords) {
    let rect = {};
    if (coords) {
      let coordsArray = coords.split(",");
      if (coordsArray.length >= 2) {
        rect.left = this.toInt(coordsArray[0]);
        rect.top = this.toInt(coordsArray[1]);

        if (coordsArray.length >= 4) {
          rect.width = this.toInt(coordsArray[2]) - this.toInt(coordsArray[0]);
          rect.height = this.toInt(coordsArray[3]) - this.toInt(coordsArray[1]);
        }
      }
    }
    return rect;
  },

  addressToString(address, delimiter) {
    let addrStr = "";

    if (typeof address == "object") {
      if (delimiter === undefined) {
        delimiter = ", ";
      }

      if (address && typeof address == "object") {
        if (address.unit) addrStr += (addrStr == "" ? "" : delimiter) + "Unit " + address.unit;
        if (address.street) addrStr += (addrStr == "" ? "" : delimiter) + address.street;
        if (address.city) addrStr += (addrStr == "" ? "" : delimiter) + address.city;
        if (address.province) addrStr += (addrStr == "" ? "" : delimiter) + address.province;
        if (address.postal) addrStr += (addrStr == "" ? "" : delimiter) + address.postal;
      }
    } else if (typeof address == "string") addrStr = address;

    return addrStr;
  },

  readIonicIndexedDb() {
    console.log("Read ionic indexed db");

    let companyCode = store.getters.storeCompanyCode;
    return new Promise((resolve, reject) => {
      let request = window.indexedDB.open("__digidb");
      if (request) {
        request.onsuccess = function () {
          let records = [];
          let db = request.result;

          if (db.objectStoreNames.contains("_ionickv")) {
            let trans = db.transaction(["_ionickv"]);
            trans.oncomplete = () => {
              resolve(records);
            };

            let store = trans.objectStore("_ionickv");
            store.openCursor().onsuccess = e => {
              let cursor = e.target.result;
              if (cursor) {
                if (cursor.key == "VERIFIED_PHONE_NUMBERS" || cursor.key.includes(companyCode)) {
                  records.push({
                    key: cursor.key,
                    value: cursor.value,
                  });
                }

                cursor.continue();
              }
            };
          }
        };

        request.onerror = e => {
          reject(e);
        };
      }
    });
  },

  encrypt(data) {
    return CryptoJS.AES.encrypt(JSON.stringify(data), this.crypKey).toString();
  },

  decrypt(data) {
    let bytes = CryptoJS.AES.decrypt(data, this.crypKey);
    let s = bytes.toString(CryptoJS.enc.Utf8);
    try {
      return JSON.parse(s);
    } catch (err) {
      return s;
    }
  },
};
